module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAbklEQVR42u3aQQ0AMAACMSzMxPwrmSUmhJKcgb5J2ywXAAAAAAAAAAAAAADGAd65XQoAAAAAAAAAAAAAAAAAAAAAAAAAgHWA7g0AAAAAAAAAAAAAAAAAAAAAAAAAgHUAT1EAAAAAAAAAAAAAAHb6o+fu4ol3MS8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Indonesia.png
// module id = M+fJ
// module chunks = 0 62 63